"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Analytics Events
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnumAcuity = void 0;
/**
 * This is the obfuscated acuity level of the user based on the max of their PHQ or GAD score.
 */
exports.EnumAcuity = {
    Maverick: 'Maverick',
    Iceman: 'Iceman',
    Goose: 'Goose',
    Hollywood: 'Hollywood',
    Viper: 'Viper',
};
//# sourceMappingURL=enum-acuity.js.map